import { useState, useEffect } from "react";
// import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import {DatePicker, LocalizationProvider} from '@mui/lab'
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import SnoozeIcon from "@material-ui/icons/Snooze";
import AlarmIcon from "@material-ui/icons/AddAlarm";
import { IconButton, InputAdornment, InputLabel } from "@material-ui/core";
import './style.scss';

export default function DateAndTimePicker({ label, date, handleDateChange }) {
    const [selectedDate, setSelectedDate] = useState(date);

    useEffect(() => {
        setSelectedDate(date)
    }, [date]);

    const handleDatePicker = (date) => {
        setSelectedDate(date)
        handleDateChange(date);
    }

    return (
        <>
            <InputLabel className='input-label'>{label}</InputLabel>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                    autoOk
                    hideTabs
                    placeholder="Select date"
                    inputVariant='outlined'
                    value={selectedDate}
                    format={'MM-dd-yyyy'}
                    style={{ width: '100%' }}
                    onChange={handleDatePicker}
                    allowKeyboardControl={false}
                    leftArrowIcon={<AlarmIcon />}
                    leftArrowButtonProps={{ "aria-label": "Prev month" }}
                    rightArrowButtonProps={{ "aria-label": "Next month" }}
                    rightArrowIcon={<SnoozeIcon />}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton>
                                    <AlarmIcon />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
            </LocalizationProvider>
        </>
    );
}